// Fotografias de arquivo: não representam os fatos investigados nem endosso dos autores.
export const publicPhotos = {
  'flavio-oficial': {
    path: '/retratos/flavio-bolsonaro-oficial', width: 480, height: 509,
    alt: 'Retrato oficial de Flávio Bolsonaro, com terno escuro e a bandeira do Rio de Janeiro ao fundo.',
    caption: 'Flávio Bolsonaro · retrato oficial, 2019',
    author: 'Agência Senado',
    source: 'https://commons.wikimedia.org/wiki/File:Foto_oficial_do_senador_Fl%C3%A1vio_Bolsonaro_(v._AgSen).jpg',
    license: 'Uso com atribuição', licenseUrl: 'https://www12.senado.leg.br/noticias/politica-de-uso',
    changes: 'Redimensionamento e conversão para WebP/AVIF; enquadramento responsivo.',
  },
  'flavio-plenario': {
    path: '/retratos/flavio-bolsonaro-plenario', width: 640, height: 891,
    alt: 'Flávio Bolsonaro no plenário do Senado, de terno azul, em setembro de 2026.',
    caption: 'Flávio Bolsonaro no Senado · 1º set. 2026',
    author: 'Carlos Moura / Agência Senado; recorte: Locket Lulis 2',
    source: 'https://commons.wikimedia.org/wiki/File:Fl%C3%A1vio_Bolsonaro_-_55503015238_(cropped_2).jpg',
    license: 'CC BY-SA 4.0', licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
    changes: 'Recorte da versão do Commons, redimensionado e convertido para WebP/AVIF. Versões sob CC BY-SA 4.0.',
  },
  'jair-pr': {
    path: '/retratos/jair-bolsonaro-pr', width: 480, height: 639,
    alt: 'Jair Bolsonaro durante pronunciamento à Presidência, em abril de 2019.',
    caption: 'Jair Bolsonaro · pronunciamento, 24 abr. 2019',
    author: 'Isac Nóbrega / PR; recorte: Wabbuh',
    source: 'https://commons.wikimedia.org/wiki/File:Jair_Bolsonaro_2019_Portrait_(3x4_cropped).jpg',
    license: 'CC BY 2.0', licenseUrl: 'https://creativecommons.org/licenses/by/2.0/',
    changes: 'Recorte da versão do Commons, redimensionado e convertido para WebP/AVIF.',
  },
  'audiencia-defesa': {
    path: '/retratos/bolsonaro-audiencia-defesa-2022', width: 1100, height: 733,
    alt: 'Jair Bolsonaro sentado à mesa com autoridades militares durante audiência no Planalto em março de 2022.',
    caption: 'Audiência com o então ministro da Defesa, Braga Netto · 28 mar. 2022. Foto de arquivo, anterior aos episódios investigados.',
    author: 'Clauber Cleber Caetano / PR',
    source: 'https://commons.wikimedia.org/wiki/File:2022_Ministro_de_Estado_da_Defesa,_General_Braga_Netto_-_51966851939.jpg',
    license: 'CC BY 2.0', licenseUrl: 'https://creativecommons.org/licenses/by/2.0/',
    changes: 'Redimensionamento e conversão para WebP/AVIF; sem montagem ou alteração de conteúdo.',
  },
} as const

export type PublicPhotoId = keyof typeof publicPhotos
